"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Validates if input is a real string.
 *
 * @export
 * @class IsStringValidator
 * @implements {PropertyValidator<any>}
 */
class IsStringValidator {
    isValid(input) {
        return input instanceof String || typeof input === "string";
    }
}
exports.IsStringValidator = IsStringValidator;
//# sourceMappingURL=IsStringValidator.js.map